import React from 'react'
import cn from 'classnames'
import { Tile } from './types'
import { Icons } from './Icons'
import { RawSvg } from './RawSvg'
import { getAssetUrl, getImageUrl } from '../utils/fileUtils'
import { colourStringToRgbaParts, isLight } from '../utils/colorUtils'

interface Props {
  tile: Tile
}

const colorIsLight = (color: string) => {
  const rgba = colourStringToRgbaParts(color)
  return isLight(rgba)
}

export const TileComponent: React.FC<Props> = ({ tile }) => {
  const tileIdentifier = `tile-${tile.id}`
  const { title, content, tag, image, subtiles, text_color, background_color, link, information_link } = tile
  const isMobile = window.innerWidth < 640
  return (
    <div
      className="toolbox-tile"
      data-sortable-tile={tileIdentifier}
      style={isMobile ? { minHeight: 318 - 38 * Math.min(4, 5 - (subtiles ? subtiles.length : 0)) } : {}}>
      <div
        className={cn(
          'toolbox-tile-inner',
          !tile.image && !!background_color && (colorIsLight(background_color) ? 'text-dark' : 'text-light')
        )}
        style={{ color: 'inherit', backgroundColor: background_color }}>
        <div className={cn('toolbox-tile-block', text_color && `text-${text_color}`)}>
          {image && (
            <div className="toolbox-tile-image has-image">
              <img src={getImageUrl(image, '480w-1') || '#'} alt={image.title} />
            </div>
          )}
          {tile.icon_asset ? (
            <div className={`toolbox-tile-icon user-uploaded icon-ratio-${tile.icon_asset_ratio || '1-1'}`}>
              {tile.icon_asset.extension === 'svg' ? (
                <RawSvg path={getAssetUrl(tile.icon_asset)} />
              ) : (
                <img src={getImageUrl(tile.icon_asset, 'favicon-64') || '#'} alt={tile.icon_asset.title} />
              )}
            </div>
          ) : tile.icon ? (
            <div className="toolbox-tile-icon">
              <RawSvg path={`/assets/icons/${tile.icon}.svg`} />
            </div>
          ) : null}
          <h3 className="toolbox-tile-title" data-sortable-attr="ALPHABETICAL">
            {title}
          </h3>
          <div className="toolbox-tile-meta">
            {tag && <div className="toolbox-tile-tag" children={tag} />}
            {information_link && (
              <div className="toolbox-tile-info">
                <a href={information_link.url}>
                  <Icons.ErrorOutline />
                </a>
              </div>
            )}
          </div>
          {link && (
            <>
              <div className="toolbox-tile-anchor-arrow">
                <Icons.Play />
              </div>
              <a className="toolbox-tile-block-link toolbox-tile-link" href={link.url} />
            </>
          )}
          {content && <div className="toolbox-tile-overlay">{content}</div>}
        </div>
        {subtiles && subtiles.length > 0 && (
          <div className="toolbox-tile-subtiles">
            {subtiles.map((subtile) => (
              <a
                key={subtile.id}
                href={subtile.link?.url || subtile.tile?.link?.url || '#'}
                className={cn('toolbox-tile-subtile', subtiles.length >= 5 && 'small-subtile')}
                style={{ color: 'inherit' }}>
                <span>{subtile.title || subtile.link?.title || subtile.tile?.title}</span>
                <Icons.Play />
              </a>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
